{
  "failed": "Échec",
  "moreChanges_one": "· +{{count}} autre modification",
  "moreChanges_many": "· +{{count}} autres modifications",
  "moreChanges_other": "· +{{count}} autres modifications",
  "actors": {
    "system": "Système"
  },
  "values": {
    "yes": "Oui",
    "no": "Non"
  },
  "actions": {
    "LOGIN": "s'est connecté",
    "LOGOUT": "s'est déconnecté",
    "LOGIN_FAILED": "n'a pas pu se connecter",
    "PASSWORD_RESET": "a réinitialisé un mot de passe",
    "PASSWORD_RESET_REQUESTED": "a demandé un lien de réinitialisation",
    "PASSWORD_CHANGED": "a changé son mot de passe",
    "PRODUCT_CREATED": "a créé un produit",
    "PRODUCT_UPDATED": "a modifié un produit",
    "PRICE_CHANGED": "a changé un prix",
    "PRODUCT_ARCHIVED": "a archivé un produit",
    "LOCATION_CREATED": "a créé un emplacement",
    "LOCATION_UPDATED": "a modifié un emplacement",
    "LOCATION_DEACTIVATED": "a désactivé un emplacement",
    "STOCK_IN": "a réceptionné du stock",
    "STOCK_OUT": "a sorti du stock",
    "ADJUSTMENT": "a ajusté le stock",
    "OPENING_STOCK": "a saisi un stock initial",
    "TRANSFER_SENT": "a envoyé un transfert",
    "TRANSFER_RECEIVED": "a réceptionné un transfert",
    "TRANSFER_DIRECT": "a fait un transfert direct",
    "COUNT_VALIDATED": "a validé un inventaire",
    "OPERATION_REVERSED": "a annulé une opération",
    "NEGATIVE_STOCK_CONFIRMED": "a confirmé un stock négatif",
    "USER_CREATED": "a créé un utilisateur",
    "USER_UPDATED": "a modifié un utilisateur",
    "USER_DEACTIVATED": "a désactivé un utilisateur",
    "ROLE_CHANGED": "a changé un rôle",
    "PERMISSION_CHANGED": "a modifié les permissions d'un rôle",
    "SETTING_CHANGED": "a modifié la configuration",
    "COMPANY_PROFILE_UPDATED": "a mis à jour le profil de l'entreprise",
    "ALERT_RAISED": "a déclenché une alerte",
    "ALERT_RESOLVED": "a résolu une alerte",
    "IMPORT_COMPLETED": "a terminé un import",
    "IMPORT_FAILED": "a échoué un import",
    "BACKUP_DONE": "a fait une sauvegarde",
    "BACKUP_FAILED": "a échoué une sauvegarde",
    "PRODUCT_DELETED": "a supprimé un produit",
    "LOCATION_DELETED": "a supprimé un emplacement",
    "OPERATION_CREATED": "a commencé une opération",
    "OPERATION_CANCELLED": "a abandonné un brouillon",
    "OPERATION_SUBMITTED": "a soumis une correction à validation",
    "OPERATION_SENT_BACK": "a renvoyé une correction",
    "COUNT_STARTED": "a commencé un inventaire",
    "COUNT_CANCELLED": "a annulé un inventaire",
    "FILE_ATTACHED": "a joint un fichier",
    "FILE_REMOVED": "a retiré un fichier",
    "CUSTOMER_CREATED": "a créé un client",
    "CUSTOMER_UPDATED": "a modifié un client",
    "CUSTOMER_MERGED": "a fusionné deux clients",
    "CUSTOMER_ANONYMIZED": "a anonymisé un client",
    "CUSTOMER_DELETED": "a supprimé un client",
    "FULFILLMENT_STEP": "a fait avancer une commande",
    "ORDER_RETURNED": "a repris des articles d’une commande",
    "ORDER_CREATED": "a commencé une commande",
    "ORDER_PLACED": "a passé une commande",
    "ORDER_CHANGED": "a modifié une commande",
    "ORDER_CONFIRMED": "a confirmé une commande",
    "PICKING_CANCELLED": "a annulé le prélèvement d’une commande",
    "ORDER_CANCELLED": "a annulé une commande",
    "ORDER_COMPLETED": "a terminé une commande",
    "RESERVATION_EXPIRED": "a libéré une réservation non payée à temps",
    "PAYMENT_RECEIVED": "a enregistré un paiement",
    "PAYMENT_VOIDED": "a annulé un paiement",
    "PAYMENT_REFUNDED": "a remboursé un paiement",
    "COD_SETTLED": "a enregistré un règlement de contre-remboursement",
    "DOCUMENT_ISSUED": "a émis un document",
    "REGISTER_CREATED": "a ajouté une caisse",
    "REGISTER_UPDATED": "a modifié une caisse",
    "REGISTER_PAIRED": "a associé un navigateur à une caisse",
    "REGISTER_UNPAIRED": "a dissocié une caisse",
    "SHIFT_OPENED": "a ouvert un service",
    "CASH_MOVEMENT": "a mouvementé les espèces d’un tiroir",
    "SHIFT_CLOSED": "a fermé un service",
    "CASH_VARIANCE_APPROVED": "a approuvé un écart de caisse",
    "DRAWER_OPENED": "a ouvert le tiroir sans vente",
    "SALE_CANCELLED": "a annulé une vente à la caisse",
    "PAYMENT_CORRECTED": "a corrigé un paiement à la caisse",
    "POS_APPROVAL_GIVEN": "a autorisé une action à une caisse",
    "REFUND_WITHOUT_RECEIPT": "a repris des articles sans ticket",
    "ORDER_CUSTOMER_SET": "a rattaché un client à un ticket",
    "RESTORE_DONE": "a restauré les données depuis une sauvegarde",
    "RESTORE_FAILED": "n'a pas pu restaurer une sauvegarde",
    "SUPPLIER_CREATED": "a ajouté un fournisseur",
    "SUPPLIER_UPDATED": "a modifié un fournisseur",
    "SUPPLIER_PAYMENT_RECORDED": "a enregistré un paiement fournisseur",
    "SUPPLIER_PAYMENT_COMPLETED": "a marqué un paiement fournisseur payé",
    "SUPPLIER_PAYMENT_CANCELLED": "a annulé un paiement fournisseur",
    "SUPPLIER_PAYMENT_ALLOCATED": "a réparti de nouveau un paiement fournisseur",
    "AMOUNT_DUE_CHANGED": "a modifié un montant à payer",
    "PROMOTION_CREATED": "a créé une promotion",
    "PROMOTION_UPDATED": "a modifié une promotion",
    "PROMOTION_PAUSED": "a mis une promotion en pause",
    "PROMOTION_RESUMED": "a repris une promotion",
    "PROMOTION_ENDED": "a terminé une promotion",
    "PROMOTION_DELETED": "a supprimé une promotion",
    "DOCUMENT_DATE_CHANGED": "a changé la date d’un document"
  },
  "fields": {
    "buyQuantity": "Achetés",
    "getQuantity": "Obtenus",
    "maxSets": "Au plus, par vente",
    "tiers": "Paliers de quantité",
    "components": "Composants du pack",
    "target": "Sur quoi",
    "getTarget": "Ce qu'elle donne",
    "minQuantity": "Quantité minimale",
    "minAmount": "Montant minimal (TND)",
    "discountPercent": "Remise (%)",
    "customerTags": "Étiquettes clients",
    "maxUses": "Utilisations au total",
    "maxPerCustomer": "Utilisations par client",
    "saleType": "Type de vente",
    "channels": "Canaux",
    "startsOn": "Premier jour",
    "endsOn": "Dernier jour",
    "weekdays": "Jours",
    "fromTime": "De",
    "toTime": "À",
    "legalName": "Raison sociale",
    "tradeName": "Nom commercial",
    "taxId": "Matricule fiscal",
    "tradeRegisterNo": "N° du registre de commerce",
    "address": "Adresse",
    "city": "Ville",
    "phone": "Téléphone",
    "email": "Email",
    "website": "Site web",
    "defaultLanguage": "Langue par défaut",
    "timezone": "Fuseau horaire",
    "dateFormat": "Format des dates",
    "numberFormat": "Format des nombres",
    "fiscalYearStartMonth": "Début de l'exercice (mois)",
    "logo": "Logo",
    "order": "Ordre",
    "username": "Nom d'utilisateur",
    "fullName": "Nom complet",
    "role": "Rôle",
    "language": "Langue",
    "locationScope": "Accès aux emplacements",
    "locations": "Emplacements",
    "defaultLocation": "Emplacement par défaut",
    "status": "Statut",
    "isActive": "Actif",
    "name": "Nom",
    "symbol": "Symbole",
    "decimals": "Décimales",
    "direction": "Sens",
    "parentId": "Parent",
    "prefix": "Préfixe",
    "negativeStockPolicy": "Stock négatif",
    "quickTransfersEnabled": "Transferts rapides",
    "adjustmentApprovalThreshold": "Seuil d'approbation (TND)",
    "deadStockDays": "Stock dormant (jours)",
    "transferLateDays": "Transfert en retard (jours)",
    "countVarianceAlertPercent": "Écart d'inventaire (%)",
    "dailyDigestTime": "Heure du récapitulatif",
    "enabledLanguages": "Langues activées",
    "added": "Permissions ajoutées",
    "removed": "Permissions retirées",
    "failedAttempt": "Tentative",
    "sku": "Référence",
    "barcode": "Code-barres",
    "description": "Description",
    "category": "Catégorie",
    "brand": "Marque",
    "unit": "Unité",
    "minStock": "Stock minimum",
    "maxStock": "Stock maximum",
    "locationThresholds": "Limites par emplacement",
    "costPrice": "Prix de revient de référence",
    "sellingPrice": "Prix de vente",
    "photo": "Photo",
    "code": "Code",
    "type": "Type",
    "responsible": "Responsable",
    "responsibleUserId": "Responsable",
    "site": "Site",
    "error": "Erreur",
    "created": "Produits créés",
    "updated": "Produits mis à jour",
    "categoriesCreated": "Catégories créées",
    "brandsCreated": "Marques créées",
    "location": "Emplacement",
    "lines": "Lignes",
    "outType": "Type de sortie",
    "reason": "Motif",
    "partner": "De / vers",
    "externalReference": "Leur référence",
    "size": "Taille (octets)",
    "documents": "Enregistrements",
    "operation": "Opération",
    "note": "Note",
    "value": "Valeur (TND)",
    "from": "De",
    "to": "Vers",
    "corrections": "Corrections",
    "adjustment": "Ajustement",
    "count": "Inventaire",
    "transfer": "Transfert",
    "quantity": "Quantité",
    "min": "Minimum",
    "max": "Maximum",
    "days": "Jours",
    "limit": "Seuil",
    "percent": "Écart (%)",
    "elsewhere": "Ailleurs",
    "alertEmails": "E-mails d'alerte",
    "dailySummary": "Résumé quotidien par e-mail",
    "attachment": "Pièce jointe",
    "taxRate": "Taux de TVA",
    "listPrices": "Autres prix",
    "rate": "Taux",
    "defaultRate": "Taux par défaut",
    "priceList": "Liste de prix",
    "paymentMethods": "Moyens de paiement",
    "documentPrefix": "Préfixe des commandes",
    "fulfillmentSite": "Site de préparation",
    "pickupSites": "Points de retrait",
    "deliveryModes": "Livraison",
    "steps": "Étapes de préparation",
    "reservationMinutes": "Réservation du stock (min)",
    "personalDetails": "Données personnelles",
    "mergedFrom": "Fusionné depuis",
    "contactName": "Contact",
    "addresses": "Adresses",
    "notes": "Notes",
    "tags": "Étiquettes",
    "marketingConsent": "Accepte le marketing",
    "step": "Étape",
    "carrier": "Transporteur",
    "defaultCarrier": "Transporteur par défaut",
    "labels": "Étiquettes code-barres",
    "image": "Photo",
    "trackingNumber": "Numéro de suivi",
    "trackingUrl": "Lien de suivi",
    "cashOnDelivery": "Encaisse le contre-remboursement",
    "reservedUntil": "Réservé jusqu’au",
    "reserved": "Réservé",
    "total": "Total (TND)",
    "returnDays": "Délai de retour (jours)",
    "amount": "Montant",
    "method": "Moyen",
    "reference": "Référence",
    "document": "Document",
    "orders": "Commandes",
    "siteId": "Site",
    "receiptPrefix": "Préfixe des tickets",
    "device": "Appareil",
    "float": "Fond de caisse",
    "expectedFloat": "Fond laissé par le service précédent",
    "movementType": "Mouvement",
    "counted": "Compté",
    "expected": "Attendu",
    "variance": "Écart",
    "onlinePublished": "Vendu en ligne",
    "onlineTitle": "Titre en ligne",
    "onlineSlug": "Adresse en ligne",
    "onlineSortOrder": "Ordre en ligne",
    "onlineDescription": "Description en ligne",
    "gallery": "Photos en ligne",
    "shippingFee": "Frais de livraison",
    "storeOrigins": "Sites de la boutique",
    "stampDuty": "Timbre fiscal",
    "codSettlementDays": "Délai de règlement du contre-remboursement",
    "cashDenominations": "Billets et pièces",
    "cashVarianceLimit": "Limite d’écart de caisse",
    "shiftCloseTime": "Heure de fermeture des services",
    "blindCloseCount": "Comptage de fermeture à l’aveugle",
    "posDiscountLimitPercent": "Limite de remise des caissiers",
    "favorites": "Favoris",
    "onSale": "En vente",
    "shownOnline": "Visible en ligne",
    "slug": "Adresse",
    "placement": "Emplacement",
    "text": "Texte",
    "action": "Bouton",
    "linkType": "Ouvre",
    "linkTarget": "Lien",
    "backgroundColor": "Couleur du fond",
    "textColor": "Couleur du texte",
    "homeSections": "Blocs de la page d’accueil",
    "approvedBy": "Autorisé par",
    "permission": "Autorisation",
    "register": "Caisse",
    "partial": "Restauré en partie",
    "payee": "Payé à",
    "allocations": "Réceptions payées",
    "completedOn": "Payé le",
    "amountDue": "Montant à payer",
    "dueDate": "Échéance",
    "receivedOn": "Reçu le",
    "documentDate": "Date du document",
    "documentPrint": "Masqué sur les documents imprimés"
  },
  "notes": {
    "created": "Valeur créée",
    "updated": "Valeur modifiée",
    "activated": "Valeur activée",
    "deactivated": "Valeur désactivée",
    "deleted": "Valeur supprimée",
    "reactivated": "Réactivé",
    "seed": "Créé à l'installation",
    "system_location": "Emplacement système créé",
    "by_admin": "Réinitialisé par un administrateur",
    "via_email_link": "Réinitialisé avec le lien envoyé par email",
    "self_service": "Changé par l'utilisateur",
    "first_sign_in": "Choisi à la première connexion",
    "own_profile": "Son propre profil",
    "wrong_password": "Mot de passe erroné",
    "wrong_password_locked": "Mot de passe erroné, compte bloqué",
    "unknown_user": "Nom d'utilisateur inconnu",
    "account_locked": "Compte bloqué",
    "account_deactivated": "Compte désactivé",
    "wrong_current_password": "Mot de passe actuel erroné",
    "email_sent": "Lien envoyé par email",
    "no_matching_account": "Aucun compte correspondant",
    "no_email_on_account": "Pas d'email sur le compte",
    "restored": "Restauré depuis l'archive",
    "import": "Importé depuis un fichier",
    "location_access": "Accès à un site modifié",
    "with_site": "Fermé avec son site",
    "check_failed": "Le fichier n'a pas pu être vérifié",
    "import_failed": "L'import s'est arrêté",
    "above_threshold": "Au-dessus du seuil de validation",
    "approved": "Approuvé par un responsable",
    "negative_blocked": "Refusé : le stock négatif est bloqué",
    "negative_not_allowed": "Refusé : pas autorisé à confirmer un stock négatif",
    "entered_twice": "Saisi deux fois par erreur",
    "wrong_quantity": "Mauvaise quantité",
    "wrong_product": "Mauvais produit",
    "wrong_location": "Mauvais emplacement",
    "wrong_cost": "Mauvais coût",
    "other": "Autre raison",
    "manual": "Sauvegarde manuelle",
    "automatic": "Sauvegarde automatique",
    "closed_with_difference": "Clôturé avec un écart",
    "more_to_come": "La suite va arriver",
    "from_count": "Correction d'inventaire",
    "from_transfer": "Perte en transit",
    "negative_stock": "Stock négatif",
    "large_adjustment": "Gros ajustement",
    "low_stock": "Stock bas",
    "transfer_delayed": "Transfert en retard",
    "out_of_stock": "Rupture",
    "count_variance": "Écart d'inventaire",
    "overstock": "Surstock",
    "job_failed": "Import ou sauvegarde en échec",
    "cleared": "Le problème a été réglé",
    "read": "Fermée à la lecture",
    "decided": "Le document a été traité",
    "next_success": "L'exécution suivante a réussi",
    "new_permissions": "Nouvelles permissions de cette version",
    "note_added": "Note ajoutée",
    "request_added": "Demande ajoutée",
    "sign_up": "Inscrit en ligne",
    "guest_checkout": "A commandé en invité",
    "password_link": "Lien de mot de passe créé",
    "customerRequest": "À la demande du client",
    "outOfStock": "Rupture de stock",
    "paymentFailed": "Paiement échoué",
    "duplicate": "Saisie en double",
    "reservationExpired": "Non payée à temps",
    "changedMind": "A changé d’avis",
    "defective": "Défectueux",
    "wrongItem": "Mauvais article",
    "damaged": "Endommagé",
    "pos": "Au comptoir",
    "online": "Boutique en ligne",
    "backOffice": "Back-office",
    "cod_settlement": "Versé par le livreur",
    "invoice": "Facture",
    "creditNote": "Avoir",
    "receipt": "Ticket",
    "test": "Prestataire de paiement de test",
    "overpaid": "Le prestataire a encaissé plus que le dû de la commande",
    "pendingApproval": "Attend l’approbation de l’écart par un responsable",
    "order_to_prepare": "Commande à préparer",
    "cod_overdue": "Contre-remboursement non réglé",
    "shift_open_late": "Service encore ouvert",
    "cash_variance": "Écart de caisse à approuver",
    "confirmed_duplicate": "enregistré malgré un paiement semblable",
    "goods_value": "retour à la valeur des marchandises"
  },
  "title": "Journal d'activité",
  "readOnly": "Lecture seule",
  "subtitle": "Chaque action d'une personne ou du système. Personne ne peut modifier ni supprimer ces enregistrements, pas même un administrateur.",
  "export": "Exporter vers Excel",
  "families": {
    "authentication": "Connexions",
    "masterData": "Produits et emplacements",
    "stock": "Stock",
    "usersAndConfiguration": "Utilisateurs et paramètres",
    "sales": "Ventes et clients",
    "purchases": "Fournisseurs",
    "promotions": "Promotions",
    "system": "Système"
  },
  "tabs": {
    "all": "Toutes les actions",
    "movements": "Mouvements de stock",
    "signIns": "Connexions",
    "settings": "Paramètres et utilisateurs"
  },
  "filters": {
    "search": "Référence, produit ou numéro TX",
    "date": "Date",
    "periods": {
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "7d": "7 derniers jours",
      "30d": "30 derniers jours",
      "any": "Toutes les dates"
    },
    "who": "Qui",
    "everyone": "Tout le monde",
    "action": "Action",
    "operationType": "Opération",
    "allTypes": "Tous les types",
    "location": "Emplacement",
    "allLocations": "Tous les emplacements"
  },
  "columns": {
    "time": "Heure",
    "who": "Qui",
    "what": "Ce qui s'est passé",
    "reference": "Référence"
  },
  "ledger": {
    "when": "Quand",
    "document": "Document",
    "product": "Produit",
    "location": "Emplacement",
    "change": "Variation",
    "unitCost": "Coût unitaire",
    "balanceAfter": "Solde après",
    "by": "Par",
    "reversal": "contrepassation",
    "negative": "Négatif"
  },
  "detail": {
    "title": "Enregistrement",
    "pick": "Choisissez une ligne pour voir le détail : valeurs avant et après, mouvements écrits, appareil.",
    "when": "{{when}}",
    "before": "Avant",
    "after": "Après",
    "actionType": "Type d'action",
    "target": "Concerne",
    "reference": "Référence",
    "result": "Résultat",
    "success": "Réussi",
    "note": "Note",
    "device": "Appareil",
    "ip": "Adresse IP",
    "movements_one": "{{count}} mouvement de stock",
    "movements_many": "{{count}} mouvements de stock",
    "movements_other": "{{count}} mouvements de stock",
    "openOperation": "Ouvrir {{number}}",
    "open": "Ouvrir"
  },
  "empty": "Rien d’enregistré avec ces filtres.",
  "showing_one": "{{count}} enregistrement affiché",
  "showing_many": "{{count}} enregistrements affichés",
  "showing_other": "{{count}} enregistrements affichés",
  "loadMore": "Afficher plus"
}
